import {
    ADMIN_GET_ACCOUNT_TYPE_MAPPING_SUCCESS,
    ADMIN_GET_ACCOUNT_TYPE_MAPPING_FAILED,
    LOADING_ADMIN_GET_ACCOUNT_TYPE_MAPPING,
    NETWORK_ERROR_ADMIN_GET_ACCOUNT_TYPE_MAPPING
} from "../types/index";
import { adminServices } from "../../config/axios";

const adminGetAccountTypeMapping =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_ADMIN_GET_ACCOUNT_TYPE_MAPPING });
        await adminServices
            .post("getaccountTypeMapping", userData, { headers: { AuthToken: authTokenIs } })
            .then((res) => {
                switch (res.data.status) {
                    case "success":
                        dispatch({ type: ADMIN_GET_ACCOUNT_TYPE_MAPPING_SUCCESS, payload: res.data });
                        break;
                    default:
                        dispatch({ type: ADMIN_GET_ACCOUNT_TYPE_MAPPING_FAILED, payload: res.data });
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_ADMIN_GET_ACCOUNT_TYPE_MAPPING,
                    payload: err
                });
            });
    };

export { adminGetAccountTypeMapping };
